import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'

import Login from '../pages/Login'
import Register from '../pages/Register'
import Dashboard from '../pages/Dashboard'
import GroupEditor from '../pages/GroupEditor'
import PublicGroup from '../pages/PublicGroup'
import Feed from '../pages/Feed'
import Users from '../pages/Users'
import Profile from '../pages/Profile'
import { getSession, getIsAdmin } from '../utils/session'

// Any signed-in user (admin or viewer). Guests go to /login.
function Protected({ children }) {
  if (!getSession()) return <Navigate to="/login" replace />
  return children
}

// Admin-only. Guests go to /login; signed-in viewers are bounced to the feed.
function AdminOnly({ children }) {
  if (!getSession()) return <Navigate to="/login" replace />
  if (!getIsAdmin()) return <Navigate to="/" replace />
  return children
}

function R() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Signed-in viewers + admins */}
        <Route path="/" element={<Protected><Feed /></Protected>} />
        <Route path="/g/:slug" element={<Protected><PublicGroup /></Protected>} />
        <Route path="/profile" element={<Protected><Profile /></Protected>} />

        {/* Admin app */}
        <Route path="/admin" element={<AdminOnly><Dashboard /></AdminOnly>} />
        <Route path="/admin/users" element={<AdminOnly><Users /></AdminOnly>} />
        <Route path="/groups/:groupId/edit" element={<AdminOnly><GroupEditor /></AdminOnly>} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default R
